'use es6';

import { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedList from 'I18n/components/FormattedList';
import Code from 'UIComponents/elements/Code';
import { jsx as _jsx } from "react/jsx-runtime";
export default class TypesList extends Component {
  render() {
    return /*#__PURE__*/_jsx(FormattedList, {
      children: this.props.types.map(type => /*#__PURE__*/_jsx(Code, {
        children: type
      }, type))
    });
  }
}
TypesList.propTypes = {
  types: PropTypes.arrayOf(PropTypes.string.isRequired).isRequired
};